import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("podi_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("podi_cart", JSON.stringify(items));
  }, [items]);

  const add = (item) =>
    setItems((prev) => {
      const found = prev.find((i) => i.name === item.name);
      if (found) {
        return prev.map((i) =>
          i.name === item.name ? { ...i, qty: Math.min(i.qty + 1, 10) } : i
        );
      }
      return [...prev, { name: item.name, price: item.price, image: item.image, qty: 1 }];
    });

  const dec = (name) =>
    setItems((prev) =>
      prev
        .map((i) => (i.name === name ? { ...i, qty: i.qty - 1 } : i))
        .filter((i) => i.qty > 0)
    );

  const removeItem = (name) => setItems((prev) => prev.filter((i) => i.name !== name));
  const clear = () => setItems([]);

  const { count, total } = useMemo(
    () => ({
      count: items.reduce((s, i) => s + i.qty, 0),
      total: items.reduce((s, i) => s + i.price * i.qty, 0),
    }),
    [items]
  );

  return (
    <CartContext.Provider
      value={{ items, add, dec, removeItem, clear, count, total, drawerOpen, setDrawerOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};
